import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PulseNpsOverallComponent} from './pulse-nps-overall.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [PulseNpsOverallComponent],
  imports: [
    CommonModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PulseNpsOverallComponent]
})
export class PulseNpsOverallModule {
}
